import React, { useEffect, useState } from 'react';
import { browserHistory } from 'react-router';
import Header from '../../components/Header.js';
import FilterAccordionItem from '../../components/FilterAccordionItem.js';
import Bugsnag from '../../helpers/bugsnag.js';
import withLoader from '../../common/withLoader.js';
import withSalesFilter from '../../common/withSalesFilter.js';
import { getCaseType, getHospitals, getSurgeons } from '../../utils/db.js';

function SalesFilter({
  location, setLoader, setSalesFilter, salesFilter
}) {
  const [filterObject, setFilterObject] = useState({
    CaseType: salesFilter.CaseType || [],
    Surgeon: salesFilter.Surgeon || [],
    Hospital: salesFilter.Hospital || [],
  });
  const [availableOptions, setAvailableOptions] = useState({
    CaseType: [],
    Surgeon: [],
    Hospital: [],
  });
  const [filterPage, setFilterPage] = useState('TEAM');

  const getAvailableOptions = async () => {
    const hospitals = await getHospitals();
    const surgeons = await getSurgeons();
    const caseTypes = await getCaseType();
    setAvailableOptions({
      CaseType: [...caseTypes.map((item) => item.OptionName).sort()],
      Surgeon: [...surgeons.map((item) => item.SurgeonName).sort()],
      Hospital: [...hospitals.map((item) => item.CustomerName).sort()],
    });
  };

  useEffect(() => {
    try {
      setLoader(true);
      if (location.search) {
        const queryFilterPage = location.search.split('=')[1];
        setFilterPage(queryFilterPage);
        getAvailableOptions()
          .finally(() => setLoader(false));
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }, []);

  const changeFilterOption = (filterType, filterValue) => {
    setFilterObject({
      ...filterObject,
      [filterType]: filterValue
    });
  };

  const _onSubmit = () => {
    const reducedFilterObject = {};
    Object.keys(filterObject).forEach((key) => {
      if (filterObject[key].length) {
        reducedFilterObject[key] = filterObject[key];
      }
    });
    setSalesFilter(reducedFilterObject);
    browserHistory.goBack();
  };

  return (
    <div className="list-section">
      <Header
        actionButton={{ title: 'Apply Filter', onClick: _onSubmit }}
        title="Sales Filter"
        goBack={() => browserHistory.goBack()}
      />
      <div className="container">
        <div className="accordion-filter accordion-flush">
          { filterPage === 'SURGEON' ? (
            <FilterAccordionItem
              onChange={(value) => changeFilterOption('Surgeon', value)}
              onClear={() => changeFilterOption('Surgeon', [])}
              itemList={availableOptions.Surgeon}
              id="surgeon-filter"
              title="Surgeon"
              selectedItems={filterObject.Surgeon}
              collapsed={false}
            />
          ) : null }
          { filterPage === 'HOSPITAL' ? (
            <FilterAccordionItem
              onChange={(value) => changeFilterOption('Hospital', value)}
              onClear={() => changeFilterOption('Hospital', [])}
              itemList={availableOptions.Hospital}
              id="hospital-filter"
              title="Hospital"
              selectedItems={filterObject.Hospital}
              collapsed={false}
            />
          ) : null }
          <FilterAccordionItem
            onChange={(value) => changeFilterOption('CaseType', value)}
            onClear={() => changeFilterOption('CaseType', [])}
            itemList={availableOptions.CaseType}
            id="type-filter"
            title="Type"
            selectedItems={filterObject.CaseType}
            collapsed={false}
          />
        </div>
      </div>
    </div>
  );
}

export default withSalesFilter(withLoader(SalesFilter));
